<template>
  <div>
    <div>
      <div>
        <Heading
          :level="6"
          :title="heading"
          class="magazine__sidebar__useful-links__title --left mb-2 text-label"
        />
        <slot></slot>
      </div>

      <MagazineSocialIcons
        :image="image"
        :description="description"
        class="my-4"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
const { heading } = defineProps<{
  heading: string
  image: string
  description: string
}>()
</script>
<style scoped lang="postcss">
.magazine__sidebar__useful-links__title {
  font-weight: 400;
}
</style>
